import { render, staticRenderFns } from "./DiscountField.vue?vue&type=template&id=4c89cbbd&scoped=true&"
import script from "./DiscountField.vue?vue&type=script&lang=js&"
export * from "./DiscountField.vue?vue&type=script&lang=js&"
import style0 from "./DiscountField.vue?vue&type=style&index=0&id=4c89cbbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89cbbd",
  null
  
)

export default component.exports